import StandardPhoneInput from './StandardPhoneInput';
export default StandardPhoneInput;